import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Upload } from 'antd'
import { array, bool, func, object, oneOfType, shape, string } from 'prop-types'
import React, { useState } from 'react'
import { errorMessage } from 'services/messager'
import { putObjectToS3 } from 'services/s3Upload'

import InfoField from '~/components/infoField'

const FileField = ({
	pageFieldsData,
	inputValue,
	className,
	visible,
	form,
	onChange,
}) => {
	const { label, variable, info, optional, multiple } = pageFieldsData

	const [fileList, setFileList] = useState(() => {
		if (form.getFieldValue(variable.name) === undefined) {
			form.setFieldsValue({
				[variable.name]: inputValue ?? [],
			})
			return Array.isArray(inputValue) ? inputValue : []
		} else {
			return form.getFieldValue(variable.name)
		}
	})

	const handleChange = (value) => {
		if (form)
			form.setFieldsValue({
				[variable.name]: value.fileList.map((file) => ({
					uid: file.uid,
					name: file.name,
				})),
			})
		setFileList(value.fileList)

		if (onChange) onChange()
	}

	const beforeUpload = (file) => {
		const isPdf = file.type === 'application/pdf'
		if (!isPdf) {
			errorMessage({ content: 'Anexos precisam ser pdfs!' })
		}
		const isLt10M = file.size / 1024 / 1024 < 10
		if (!isLt10M) {
			errorMessage({ content: 'O arquivo pode ter no máximo 10MB!' })
		}
		const lessThan10Files = fileList.length < 10
		if (!lessThan10Files) {
			errorMessage({ content: 'Você pode anexar no máximo 10 arquivos!' })
		}
		return isPdf && isLt10M && lessThan10Files ? true : Upload.LIST_IGNORE
	}

	const getFileData = (file, callback) => {
		const reader = new FileReader()
		reader.addEventListener('load', () => callback(reader.result))
		reader.readAsArrayBuffer(file)
	}

	const uploadToS3 = async ({ data, file, onProgress, onSuccess, onError }) => {
		try {
			const result = await putObjectToS3({
				key: file.name,
				body: data,
				contentType: file.type,
			})
			onProgress({ percent: 100 })
			onSuccess(result, file)
		} catch (error) {
			console.log(error)
			errorMessage({ content: 'O upload do arquivo falhou!' })
			onError(error, file)
		}
	}

	const customRequestFunction = ({ file, onProgress, onSuccess, onError }) => {
		getFileData(file, (data) => {
			uploadToS3({ data, file, onProgress, onSuccess, onError })
		})
	}

	const uploadProps = {
		name: 'atachments',
		customRequest: customRequestFunction,
		onChange: handleChange,
		multiple: multiple ?? false,
		fileList: fileList,
		beforeUpload: beforeUpload,
	}

	return (
		<Form.Item
			key={variable.name}
			name={variable.name}
			label={<InfoField label={label} info={info} />}
			className={className}
			valuePropName="fileListReduced"
			colon={false}
			rules={
				visible && [
					{ required: !optional, message: 'Este campo é obrigatório.' },
				]
			}>
			<Upload {...uploadProps}>
				<Button icon={<UploadOutlined />}>Click to Upload</Button>
			</Upload>
		</Form.Item>
	)
}

FileField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: object.isRequired,
		info: string,
	}).isRequired,
	onChange: func,
	className: string,
	form: object,
	inputValue: oneOfType([string, array]),
	visible: bool,
}

FileField.defaultProps = {
	visible: true,
}

export default FileField
